import { render } from "./topicCheck.vue?vue&type=template&id=273035ae&scoped=true"
import script from "./topicCheck.vue?vue&type=script&lang=js"
export * from "./topicCheck.vue?vue&type=script&lang=js"

import "./topicCheck.vue?vue&type=style&index=0&id=273035ae&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273035ae"]])

export default __exports__